export const performRequest = async( url, formData ) => {
    return await fetch(url, {
        method: "POST", 
        mode: "cors", 
        cache: "no-cache", 
        credentials: "same-origin", 
        body: formData
    })
}